// vue
import Vue from 'vue';
// bootstrap
import BootstrapVue from 'bootstrap-vue';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import './styles/index.scss';
// OpenLayers
import 'ol/ol.css';
// progressbar
import 'nprogress/nprogress.css';
// applicatie imports
import App from './App.vue';
import router from './router/web';
import store from './store/nedGlobe/web';
// services
import nedglobeApi from './services/nedglobeapi';
import createPolygonService from './services/polygon';
import createSystemService from './services/system';
import i18nGroupPlugin from './services/utilities/i18nGroupPlugin.js';
import usageDirective from './services/utilities/usageRecordPlugin';

// Internationalization plugin
import i18n from './i18n';

const appInsights = new ApplicationInsights({
    config: {
        instrumentationKey: process.env.VUE_APP_INSIGHTS_INSTRUMENTATION_KEY || '1045db85-8b04-4f95-82df-cadbd300fad1'
        /* ...Other Configuration Options... */
    }
});
appInsights.loadAppInsights();
store.commit('SET_APPLICATION_INSIGHTS', appInsights);
window.onload = function () {
    store.dispatch('trackPageUsageStart', '/web');
    window.addEventListener('beforeunload', function (e) {
        store.dispatch('trackPageUsageStop', '/web');
    });
};

Vue.config.productionTip = false;

const polygonService = createPolygonService(nedglobeApi);
const systemService = createSystemService();

// Register components in the BaseComponents folder starting with x-
const requireComponent = require.context(
    // The relative path of the BaseComponents folder
    './components/BaseComponents',
    // Whether or not to look in subfolders
    false,
    // The regular expression used to match base component filenames
    /x-(?!alert)\w+\.(vue|js)$/
);
requireComponent.keys().forEach(fileName => {
    // Get component config
    const componentConfig = requireComponent(fileName);

    // Get PascalCase name of component
    const componentName = upperFirst(
        camelCase(
            // Gets the file name regardless of folder depth
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    );

    // Register component globally
    Vue.component(
        componentName,
        // Look for the component options on `.default`, which will
        // exist if the component was exported with `export default`,
        // otherwise fall back to module's root.
        componentConfig.default || componentConfig
    );
});

Vue.use(BootstrapVue);
Vue.use(i18nGroupPlugin);
Vue.use(usageDirective(store));

new Vue({
    router,
    store: store,

    // services
    nedglobeApi,
    polygonService,
    systemService,
    i18n,
    render: h => h(App)
}).$mount('#app');
